import { Tab as MuiTab, tabClasses, styled } from '@mui/material';
var Tab = styled(MuiTab)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&." + tabClasses.root] = {
            fontWeight: 500,
            padding: '16px',
            maxWidth: 'inherit',
            minWidth: 'inherit',
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        },
        _b["&." + tabClasses.selected] = {
            // fontWeight: 500,
            '&:hover': {
                backgroundColor: 'transparent'
            }
        },
        _b);
});
export default Tab;
